export default "__VITE_ASSET__CBI9qQtO__"